import React , {useEffect, useState} from 'react'
import models from '../../Utils/SampleDataModels.json'
import { useFormContext } from '../createworkflow/FormContext'
import { ErrorBoundary } from '../common/ErrorBoundary'

export default function Stage6() {

  const { formData, updateFormData } = useFormContext();

    // State to hold selected model IDs
    const [selectedModels, setSelectedModels] = useState([]);

    const handleCheckboxChange = (modelId) => {
      setSelectedModels((prevSelectedModels) => {
        // If the modelId is already selected, remove it
        let updatedSelectedModels = prevSelectedModels.includes(modelId)
          ? prevSelectedModels.filter((id) => id !== modelId)
          : [...prevSelectedModels, modelId];
  
        return updatedSelectedModels; // Return updated value for state
      });
    };
  
    // Effect to update formData when selectedModels changes
    useEffect(() => {
      updateFormData('stage6', {
        ...formData.stage6,
        models: selectedModels, // Use the updated array directly
      });
    }, [selectedModels]); // Dependency on selectedModels to update formData
  

      // Effect to initialize selectedModels from formData on component load
  useEffect(() => {
    if (formData.stage6?.models) {
      setSelectedModels(formData.stage6.models);
    }
  }, []); 

  return (
    <ErrorBoundary>
    <div>
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="table-responsive">
          <table class="table dataselectiontable table-bordered">
            <thead>
              <tr>
                <th colspan="2">Listing For Selected Data </th>
              </tr>
            </thead>
            <tbody>
            {models.map((model) => (
          <tr key={model.id}>
            <td>
              <div className="checkbox">
                <label>
                  <input type="checkbox"
                     value={model.id}
                     checked={selectedModels.includes(model.id)}
                     onChange={() => handleCheckboxChange(model.id)} // Handle checkbox toggle
                      />
                  {model.name}
                </label>
              </div>
            </td>
            <td>{model.description}</td>
          </tr>
        ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </ErrorBoundary>
  )
}
